export default __webpack_public_path__ + "static/media/Group4.75cf5afd.svg";